/**
 * creator:linhe
 * date:2019/05/29
 * class:静态变量
 */
//用户登录信息
const USER_ACCOUNT = 'USER_ACCOUNT';

//用户信息
const USER_INFO = 'USER_INFO';

//登录用户的Admin
const USER_ADMIN = 'USER_ADMIN';
//token
const USER_TOKEN = 'USER_TOKEN';
//用户路由
const USER_ROUTER = 'USER_ROUTER';
//历史路由参数
const HISTORY_ROUTER_QUERY = 'HISTORY_ROUTER_QUERY';
//进入模式
const LOGIN_TYPE = 'LOGIN_TYPE';
//服务器路径
//生产地址
const SERVER_URL = 'https://xinhuotai.yinxinhudong.com/';
const SERVER_IMG_URL = 'https://xinhuotai.yinxinhudong.com';
// const SERVER_URL = 'https://yinghuotai.yinxinhudong.com/';
// const SERVER_IMG_URL = 'https://yinghuotai.yinxinhudong.com';
// const SERVER_URL = 'http://www.zhenxin.com/index.php';
// const SERVER_IMG_URL = 'http://www.zhenxin.com';

//当前路径
//生产地址
const URL = 'https://xinhuotai.yinxinhudong.com/#/';
// const URL = 'http://192.168.1.25:9001/#/';

//上传路径
const UPLOADING_URL = SERVER_URL + '/uploadController';
//图片路径
const IMG_URL = SERVER_URL + '/auth/permission/files/';
// const IMG_URL =
//   'https://scsxwhbucket.oss-cn-guangzhou.aliyuncs.com/Users/nft/nftpaltform-master/';
//模型路径
const MX_URL = IMG_URL + 'base4/base.gltf';

//上传图片大小(单位MB)
const UPLOADING_IMG_SIZE = 1;
//热门搜索搜索历史
const SEARCH_HISTORY = 'SEARCH_HISTORY';
//跳转
const SELECT_ID = 'SELECT_ID';
//记住密码
const USER_REMEMBER_PASSWORD = 'USER_REMEMBER_PASSWORD';
//
const CAROUSEL_CONTENT = 'CAROUSEL_CONTENT';

//客户ID
const CUSTOMER_INFO_ID = 'CUSTOMER_INFO_ID';
//当前使用模板
const TEMPLATE = 'TEMPLATE';
//logo路径
const LOGO = 'LOGO';
//导航栏数据
const TAB_BAR_DATA = 'TAB_BAR_DATA';
//藏馆选择
const LIBRARY_SELECTION = 'LIBRARY_SELECTION';
//安卓高度
const ANDROID_HEIGHT = 'ANDROID_HEIGHT';
//邀请码
const INVITATION_CODE = 'INVITATION_CODE';
//图片裁剪
const RESULT_BASE = 'RESULT_BASE';

const RESULT_FILE = 'RESULT_FILE';

const BLIND_SELECT = 'BLIND_SELECT';

const BLIND_STATUS = 'BLIND_STATUS';

const BOX_INDEX = 'BOX_INDEX';

const ORDER_INDEX = 'ORDER_INDEX';
export default {
  USER_ACCOUNT: USER_ACCOUNT,
  USER_INFO: USER_INFO,
  USER_ADMIN: USER_ADMIN,
  USER_TOKEN: USER_TOKEN,
  USER_ROUTER: USER_ROUTER,
  SERVER_URL: SERVER_URL,
  SERVER_IMG_URL: SERVER_IMG_URL,
  UPLOADING_URL: UPLOADING_URL,
  IMG_URL: IMG_URL,
  CAROUSEL_CONTENT: CAROUSEL_CONTENT,
  LOGIN_TYPE: LOGIN_TYPE,
  UPLOADING_IMG_SIZE: UPLOADING_IMG_SIZE,
  SEARCH_HISTORY: SEARCH_HISTORY,
  HISTORY_ROUTER_QUERY: HISTORY_ROUTER_QUERY,
  SELECT_ID: SELECT_ID,
  USER_REMEMBER_PASSWORD: USER_REMEMBER_PASSWORD,
  CUSTOMER_INFO_ID: CUSTOMER_INFO_ID,
  TEMPLATE: TEMPLATE,
  LOGO: LOGO,
  TAB_BAR_DATA: TAB_BAR_DATA,
  MX_URL: MX_URL,
  LIBRARY_SELECTION: LIBRARY_SELECTION,
  ANDROID_HEIGHT: ANDROID_HEIGHT,
  INVITATION_CODE: INVITATION_CODE,
  RESULT_BASE: RESULT_BASE,
  RESULT_FILE: RESULT_FILE,
  BLIND_SELECT: BLIND_SELECT,
  BLIND_STATUS: BLIND_STATUS,
  BOX_INDEX: BOX_INDEX,
  ORDER_INDEX: ORDER_INDEX,
  URL: URL
};
